var DEFAULT_VISIBLE_OPTIONS = 5;
var SIZE_TO_CLASSNAME_MAP = {
    s: 'size-48',
    m: 'size-56',
    l: 'size-64',
    xl: 'size-72',
    40: 'size-40',
    48: 'size-48',
    56: 'size-56',
    64: 'size-64',
    72: 'size-72',
};

export { DEFAULT_VISIBLE_OPTIONS, SIZE_TO_CLASSNAME_MAP };
